import { ReactNode } from "react";

type NoDataFoundProps = {
  image: ReactNode | string;
  title: ReactNode | string;
  titleClass?: string;
  descriptionClass?: string;
  description?: ReactNode | string;
  action?: ReactNode;
  hAuto?: boolean;
};

export default function NoDataFound({
  image,
  title,
  description,
  titleClass,
  descriptionClass,
  action,
  hAuto,
}: NoDataFoundProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center ${
        hAuto ? "h-auto" : "h-full"
      } w-full gap-5 `}
    >
      <div className="text-title-secondary">{image}</div>
      <div>
        <h4 className={`text-2xl text-title-secondary ${titleClass}`}>
          {title}
        </h4>
        {description && <p className={descriptionClass}>{description}</p>}
      </div>
      {action}
    </div>
  );
}
